import { BoxProps } from 'UIKit/Box/types'
import { RouteConfig } from 'config/constants/route'
import { useCrisp, useElementContainerChatboxRendered, useIconChatHandle } from 'hooks/useCrisp'
import { useIsomorphicEffect } from 'hooks/useIsomorphicEffect'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { useRouter } from 'hooks/useRouter'
import React, { useRef } from 'react'
import { useAppSelector } from 'state'
import styled from 'styled-components'
import { AutoColumn } from '../Column'
import BonusItem from './components/BonusItem'
import HomeItem from './components/HomeItem'
import MenuItem from './components/MenuItem'
import UserItem from './components/UserItem'

const StyledWrapper = styled(AutoColumn).attrs({ gap: 'lg', justify: 'center' })<{ $isOpenSearch: boolean }>`
  grid-template-columns: repeat(4, 1fr);

  position: fixed;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: ${({ theme }) => theme.colors.inputDefault};

  align-items: center;
  box-sizing: border-box;
  padding: 0 8px;

  a {
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    display: none !important;
  }
`

const MENU_ITEMS = [MenuItem, HomeItem, BonusItem, UserItem]
const BottomBar: React.FC<BoxProps> = ({ ...props }) => {
  const { isMobile, isMd } = useMatchBreakpoints()
  const { hideIconChat, visibleIconChat } = useIconChatHandle()

  const crisp = useCrisp()
  const elementContainerChatbox = useElementContainerChatboxRendered()
  const refToggleOpen = useRef(null)

  const isOpenSearch = useAppSelector((state) => state.app.isSearchOpen)

  const { asPath, prefetch } = useRouter()

  useIsomorphicEffect(() => {
    const prefetchRoutes = [RouteConfig.Home, RouteConfig.BonusCenter, RouteConfig.MobileAccount]

    prefetchRoutes
      .filter((route) => route !== asPath)
      .forEach((route) => {
        prefetch(route)
      })
  }, [asPath])

  useIsomorphicEffect(() => {
    if (elementContainerChatbox && crisp) {
      if (isMobile || isMd) {
        crisp.push([
          'on',
          'chat:closed',
          () => {
            hideIconChat()
            refToggleOpen.current = false
          },
        ])

        crisp.push([
          'on',
          'message:received',
          () => {
            handleCheckCountMessage()
          },
        ])

        handleCheckCountMessage()
      } else {
        try {
          crisp.push(['off', 'chat:closed'])
          crisp.push(['off', 'message:received'])
        } catch (e) {}

        visibleIconChat()
      }
    }
  }, [crisp, isMobile, isMd, elementContainerChatbox])

  const handleCheckCountMessage = () => {
    const isHaveMessage = crisp.get('chat:unread:count') > 0
    if (isHaveMessage) {
      visibleIconChat()
    } else {
      hideIconChat()
    }
  }

  return (
    <StyledWrapper id="bottombar" {...props} $isOpenSearch={isOpenSearch} className="safe-fixed">
      {MENU_ITEMS.map((Component, index) => (
        <Component key={`bottom-bar-item-${index}`} />
      ))}
    </StyledWrapper>
  )
}

export default React.memo(BottomBar)
